export const Intray = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_293_24144)">
      <path
        d="M12.25 0.583984H1.75C1.28587 0.583984 0.840752 0.768359 0.512563 1.09655C0.184374 1.42474 0 1.86986 0 2.33398L0 13.4173H14V2.33398C14 1.86986 13.8156 1.42474 13.4874 1.09655C13.1592 0.768359 12.7141 0.583984 12.25 0.583984ZM1.75 1.75065H12.25C12.4047 1.75065 12.5531 1.81211 12.6625 1.92151C12.7719 2.0309 12.8333 2.17927 12.8333 2.33398V2.72307L8.23783 7.31915C7.90908 7.64658 7.46399 7.83042 7 7.83042C6.53601 7.83042 6.09092 7.64658 5.76217 7.31915L1.16667 2.72307V2.33398C1.16667 2.17927 1.22812 2.0309 1.33752 1.92151C1.44692 1.81211 1.59529 1.75065 1.75 1.75065ZM1.16667 12.2507V4.37565L4.93733 8.14398C5.48487 8.69013 6.22665 8.99684 7 8.99684C7.77335 8.99684 8.51513 8.69013 9.06267 8.14398L12.8333 4.37565V12.2507H1.16667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24144">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
